// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "th[data-v-53179f02] {\n  color: #2669a0;\n}\ntd[data-v-53179f02] {\n  font-size: 1rem;\n}\n@media screen and (max-width: 768px) {\ntd[data-v-53179f02] {\n    font-size: 0.9rem;\n    word-break: break-all;\n    text-align: right !important;\n}\n}", ""]);
// Exports
module.exports = exports;
